import { render, staticRenderFns } from "./GiveDocumentOpinion.vue?vue&type=template&id=4cd0d826"
import script from "./GiveDocumentOpinion.vue?vue&type=script&lang=js"
export * from "./GiveDocumentOpinion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports